<template>
    <div>
        <b-breadcrumb :items="items"/>
        <div class="container-fluid" style="background-color: white">
            <br>
            <div class="row" style="margin: 10px;">
                <div class="col-sm-6">
                    <span><b>ชื่อ</b> : {{ driver.first_name }}</span>
                    <br/><br/>
                    <span><b>นามสกุล</b> : {{ driver.last_name }}</span>
                    <br/><br/>
                    <span>
                    <b>เบอร์โทรศัพท์</b> :
                    <span>{{ driver.phone }}</span>
                </span>
                </div>
                <div class="col-sm-6">
                    <span><b>ทะเบียนรถ</b> : {{ driver.license_plate }}</span>
                    <br/><br/>
                    <span><b>ค่าประกัน</b> :
                    <template v-if="form.insurance_total">
                        {{ form.insurance_total | currency }}
                    </template>
                </span>
                    <br/><br/>
                    <span><b>ค่าประกันสะสม</b> : {{ driver.insurance_fee_total | currency }}</span>
                </div>
            </div>
            <div class="row">

                <div class="col text-right">
                    <button type="button" class="btn btn-outline-danger" @click="showRemoveTransactionModal">
                        <icon name="pencil-alt"></icon>
                        เพิ่ม/ลบ เงินประกัน
                    </button>
                    &nbsp;&nbsp;
                    <button type="button" v-if="driver.cancel_status" class="btn btn-outline-danger"
                            @click="showPayBackModal">
                        จ่ายเงินคืนคนขับรถลาออก
                    </button>
                    &nbsp;&nbsp;
                </div>
            </div>
            <div class="col-12 table-responsive">
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th scope="col">วัน/เดือน/ปี ที่จ่าย</th>
                        <th scope="col">จำนวน</th>
                        <th scope="col">จำนวนคงเหลือ</th>
                        <th scope="col">ผู้ชำระ</th>
                        <th scope="col">ผู้รับเงิน</th>
                        <th scope="col">หมายเหตุ</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="data in insuranceTable"
                        :class="{'text-danger':data.amount < 0,'text-success':data.amount > 0}">
                        <td>{{ data.date | moment("DD/MM/YYYY") }}</td>
                        <td>{{ data.amount | currency }}</td>
                        <td>{{ data.balance | currency }}</td>
                        <td>{{ driver.name }}</td>
                        <td>{{ data.recipient }}</td>
                        <td>{{ data.reason }}</td>
                    </tr>
                    </tbody>
                </table>
                <br/>
                <div v-if="insuranceTable.length > 0">
                    <vue-pagination :pagination="dataPaginate"
                                    @paginate="getPage">
                    </vue-pagination>
                </div>
            </div>
            <div v-if="quit_list.length > 0">
                <table class="table table-bordered text-center">
                    <thead>
                    <tr>
                        <th scope="col">วัน/เดือน/ปี ที่จ่ายเงินคืน</th>
                        <th scope="col">จำนวนเงินที่จ่ายคืน</th>
                        <th scope="col">ช่องทางการจ่ายเงินคืน</th>
                        <th scope="col">รายละเอียด</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="data in quit_list">
                        <td>{{ data.date | moment("DD/MM/YYYY") }}</td>
                        <td>{{ data.amount | currency }}</td>
                        <td>
                            <span v-if="data.transaction_type == 1">เช็ค</span>
                            <span v-else-if="data.transaction_type == 2">เงินโอน</span>
                            <span v-else-if="data.transaction_type == 3">เงินสด</span>
                        </td>
                        <td>{{ data.transaction_details }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <b-modal hide-header hide-footer
                     ref="transaction">
                <div>
                    <h3 style="text-align: center">แก้ไขประกัน</h3>
                    <div class="row form-group">
                        <div class="col-5 text-right">เพิ่มประกันคนขับ (+)</div>
                        <div class="col-6">
                            <input type="number" class="form-control" v-model="edit_data.income"/>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-5 text-right">ลบประกันคนขับ (-)</div>
                        <div class="col-6">
                            <masked-input mask="-11111"
                                          v-model="edit_data.remove"
                                          class="form-control"
                                          type="tel"/>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-5 text-right">เหตุผลการแก้ไข <span style="color: red">*</span></div>
                        <div class="col-6">
                            <textarea class="form-control"
                                      style="min-height: 100px"
                                      v-model="edit_data.reason"
                                      placeholder="แก้ไขรายการฝากเงินประกันวันที่ 01/01/2020"></textarea>
                        </div>
                    </div>
                    <div class="col text-center">
                        <button class="btn btn-success" type="button" @click="saveEditData">
                            <icon name="save" style="width: 25px"></icon>
                            บันทึก
                        </button>&nbsp;&nbsp;
                        <button class="btn btn-secondary" type="button" @click="hideRemoveTransactionModal">
                            <icon name="times" style="width: 25px"></icon>
                            ยกเลิก
                        </button>
                    </div>
                </div>
            </b-modal>
            <b-modal size="xl" hide-header hide-footer ref="driver_pay">
                <br>
                <h2 class="text-center">วิธีการชำระเงิน</h2>
                <div class="row">
                    <div class="col col-sm-6">
                        <div class="row form-group">
                            <div class="col col-6">
                                <label class="col-form-label text-right">วันที่จ่ายเงินคืน</label>
                            </div>
                            <div class="col col-6">
                                <date-picker
                                    :id="`date${index}`"
                                    class="w-100"
                                    :format="changeFormat"
                                    :lang="lang"
                                    confirm
                                    v-model="pay.date"
                                    placeholder="ลงวันที่">
                                </date-picker>
                            </div>
                        </div>
                    </div>
                    <div class="col col-sm-6">
                        <div class="row form-group">
                            <div class="col col-6">
                                <label class="col-form-label text-right">ยอดที่ต้องชำระ</label>
                            </div>
                            <div class="col col-6">
                                <label class="col-form-label">
                                    <strong>
                                        {{ pay.total_amount | currency }}
                                    </strong>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- Cash -->
                <div class="form-group row">
                    <div class="col pl-5">
                        <input class="form-check-input"
                               type="checkbox"
                               id="type-cash"
                               v-model="transaction.checkCash"/>
                        <label class="form-check-label" for="type-cash">
                            เงินสด
                        </label>
                    </div>
                    <template v-if="transaction.checkCash">
                        <div class="col">
                            <input type="number"
                                   placeholder="จำนวนเงิน"
                                   class="form-control"
                                   v-model="transaction.cash.amount"
                                   step="0.01"/>
                        </div>
                    </template>
                </div>
                <hr>
                <!-- Cheque -->
                <div class="form-group row">
                    <div class="col pl-5">
                        <input class="form-check-input"
                               type="checkbox"
                               id="type-cheque"
                               v-model="transaction.checkCheque"/>
                        <label class="form-check-label" for="type-cheque">
                            เช็ค
                        </label>
                    </div>
                </div>
                <template v-if="transaction.checkCheque">
                    <template v-for="(data,index) in transaction.cheque">
                        <div class="form-group row">
                            <div class="col" :for="`ref_no${index}`">
                                <input type="text"
                                       :id="`ref_no${index}`"
                                       placeholder="หมายเลขเช็ค"
                                       v-model="data.ref_no"
                                       class="form-control"/>
                            </div>
                            <div class="col" :for="`date${index}`">
                                <date-picker
                                    :id="`date${index}`"
                                    v-model="data.date"
                                    class="w-100"
                                    :format="changeFormat"
                                    :lang="lang"
                                    confirm
                                    placeholder="ลงวันที่">
                                </date-picker>
                            </div>
                            <div class="col" :for="`bank_name${index}`">
                                <multiselect v-model="data.cheque_bank_id"
                                             :customLabel="labelBank"
                                             track-by="value"
                                             placeholder="ธนาคาร"
                                             :options="optionBankType">
                                </multiselect>
                            </div>
                            <div class="col">
                                <multiselect
                                    v-model="data.bank_branch"
                                    :options="optionBranch"
                                    :customLabel="labelBranch"
                                    :show-labels="false"
                                    placeholder="สาขา"
                                    track-by="id">
                                </multiselect>
                            </div>
                            <div class="col" :for="`amount${index}`">
                                <input type="number"
                                       :id="`amount${index}`"
                                       placeholder="จำนวนเงิน"
                                       v-model="data.amount"
                                       class="form-control"
                                       step="0.01"/>
                            </div>
                            <div class="col flex-grow-0">
                                <button class="btn btn-primary" @click="addCheque"
                                        v-if="(index + 1) === transaction.cheque.length">
                                    <icon name="plus"></icon>
                                </button>
                                <button class="btn btn-danger" v-if="(index + 1) < transaction.cheque.length"
                                        @click="removeCheque(index)">
                                    <icon name="minus"></icon>
                                </button>
                            </div>
                        </div>
                    </template>
                </template>
                <hr>
                <!-- Transfer -->
                <div class="form-group row">
                    <div class="col pl-5">
                        <input class="form-check-input"
                               type="checkbox"
                               id="type-transfer"
                               v-model="transaction.checkTransfer">
                        <label class="form-check-label" for="type-transfer">
                            เงินโอน
                        </label>
                    </div>
                </div>
                <template v-if="transaction.checkTransfer">
                    <template v-for="(data,index) in transaction.transfer ">
                        <div class="form-group row">
                            <div class="col" :for="`ref_no${index}`">
                                <input type="text"
                                       placeholder="เลขบัญชีธนาคาร"
                                       v-model="data.bank"
                                       class="form-control"
                                />
                            </div>
                            <div class="col" :for="`date${index}`">
                                <date-picker
                                    :id="`date${index}`"
                                    class="w-100"
                                    :format="changeFormat"
                                    :lang="lang"
                                    confirm
                                    v-model="data.date"
                                    placeholder="ลงวันที่">
                                </date-picker>
                            </div>
                            <div class="col" :for="`amount${index}`">
                                <input type="number"
                                       :id="`amount${index}`"
                                       placeholder="จำนวนเงิน"
                                       v-model="data.amount"
                                       class="form-control"
                                       step="0.01"/>
                            </div>
                            <div class="col flex-grow-0">
                                <button class="btn btn-primary" @click="addTransfer"
                                        v-if="(index + 1) === transaction.transfer.length">
                                    <icon name="plus"></icon>
                                </button>
                                <button class="btn btn-danger" v-if="(index + 1) < transaction.transfer.length"
                                        @click="removeTransfer(index)">
                                    <icon name="minus"></icon>
                                </button>
                            </div>
                        </div>
                    </template>
                </template>
                <hr>
                <div class="form-group row">
                    <div class="col offset-6 col-sm-6 text-right">
                        <label>
                            รวมยอดเงินที่ชำระ
                        </label>
                        <h2 class="form-control-plaintext">
                            {{ calculateTransaction > 0 ? calculateTransaction : 0 | currency }}</h2>
                    </div>
                </div>
                <div class="col text-center">
                    <button class="btn btn-success" type="button" @click="addPayBack">
                        <icon name="save" style="width: 25px"></icon>
                        บันทึก
                    </button>&nbsp;&nbsp;
                    <button class="btn btn-secondary" type="button" @click="hidePayBackModal">
                        <icon name="times" style="width: 25px"></icon>
                        ยกเลิก
                    </button>
                </div>
            </b-modal>
            <!--<pre class="alert alert-primary">{{ form }}</pre>-->
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import DeleteConfirmModal from "../../Utility/DeleteConfirmModal";
import VuePagination from "../../Pagination";
import MaskedInput from 'vue-masked-input'
import DatePicker from 'vue2-datepicker'
import moment from 'moment';
import Multiselect from "vue-multiselect";

export default {
    components: {
        VuePagination,
        DeleteConfirmModal,
        MaskedInput,
        DatePicker,
        Multiselect
    },
    name: "insurance-information",
    data() {
        return {
            edit_data: {
                income: '',
                remove: '',
                reason: ''
            },
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            items: [
                {
                    text: "บันทึกการจ่ายค่าประกัน",
                    to: {name: "insurance-fee"}
                },
                {
                    text: "เพิ่มเติม",
                    active: true
                }
            ],
            pay: {
                total_amount: '',
                date: '',
                cash: {
                    amount: ''
                }
            },
            optionBranch: [],
            quit_list: []
        }
    },
    created() {
        this.$store.dispatch("InsuranceFee/getInsuranceTotal");
        this.$store.dispatch("RRPayoff/clearTransaction");
        this.pay.total_amount = this.driver.insurance_fee_total;
        this.$store.dispatch("Common/getBankBranch").then(res => {
            this.optionBranch = res;
        })
        this.$store.dispatch("InsuranceFee/getQuitData", this.driver.id).then(res => {
            this.quit_list = res;
        })
    },
    computed: {
        ...mapState({
            driver: state => {
                return state.Driver.form;
            },
            form: state => {
                return state.InsuranceFee.form
            },
            insuranceTable: state => {
                return state.InsuranceFee.insurance_data
            },
            dataPaginate: state => {
                return state.InsuranceFee.dataPaginateDetails
            },
            user: state => {
                return state.Auth.user
            },
            transaction: state => {
                return state.RRPayoff.transactions
            },
            optionBank: state => {
                return state.Bank.bank_all;
            },
            optionBankType: state => {
                return [
                    ...state.Common.bank_type.map(type => ({
                        value: type.id,
                        text: type.name
                    }))
                ];
            }
        }),
        calculateTransaction() {
            let sum_amount = 0;
            let transactions = [];
            //เงินสด
            if (this.transaction.checkCash) {
                if (this.transaction.cash.amount) {
                    transactions.push(this.transaction.cash);
                }
            }
            //เช็ค
            if (this.transaction.checkCheque) {
                this.transaction.cheque.forEach(cheque => {
                    if (cheque.ref_no && cheque.cheque_bank_id && cheque.bank_branch) {
                        this.optionBankType.forEach(data => {
                            if (data.value == cheque.cheque_bank_id) {
                                cheque.bank_name = data.text
                            }

                        });
                        if (!cheque.date) {
                            const currentDate = moment().format("YYYY-MM-DD");
                            cheque.date = currentDate;
                        } else {
                            //console.log(cheque.date);
                            cheque.date = moment(cheque.date).format("YYYY-MM-DD")
                            let date_year = moment(cheque.date).format('YYYY'); //get year
                            if (date_year <= 2000) {
                                let current_year = moment().format("YYYY");
                                cheque.date = moment(cheque.date).format(+current_year + "-MM-DD")
                            }
                        }
                        if (!cheque.amount) {
                            cheque.amount = "";
                        }
                        transactions.push(cheque);
                    }
                });

            }
            //เงินโอน
            if (this.transaction.checkTransfer) {
                this.transaction.transfer.forEach(transfer => {
                    if (transfer.bank) {
                        transfer.bank_id = transfer.bank.id;
                        if (!transfer.date) {
                            let currentDate = moment().format("YYYY-MM-DD");
                            transfer.date = currentDate;
                        } else {
                            transfer.date = moment(transfer.date).format("YYYY-MM-DD")
                            let date_year = moment(transfer.date).format('YYYY'); //get year
                            if (date_year <= 2000) {
                                let current_year = moment().format("YYYY");
                                transfer.date = moment(transfer.date).format(+current_year + "-MM-DD")
                            }
                        }
                        if (!transfer.amount) {
                            transfer.amount = "";
                        }
                        transactions.push(transfer);
                    }
                });
            }
            let price = 0;
            sum_amount = transactions.reduce((carry, detail) => {
                if (detail.amount) {
                    price = detail.amount
                } else {
                    price = 0;
                }
                return carry + parseFloat(price);
            }, 0);
            return parseFloat(sum_amount).toFixed(2);
        }
    },
    methods: {
        addPayBack() {
            let data = {
                driver_id: this.driver.id,
                date: this.pay.date,
                cash_check: this.transaction.checkCash,
                cash: this.transaction.checkCash ? this.transaction.cash : '',
                cheque_check: this.transaction.checkCheque,
                cheque: this.transaction.checkCheque ? this.transaction.cheque : '',
                tran_check: this.transaction.checkTransfer,
                tran: this.transaction.checkTransfer ? this.transaction.transfer : '',
                total: this.calculateTransaction,
            }
            this.$store.dispatch("InsuranceFee/quit", data).then(() => {
                this.hidePayBackModal();
                this.$store.dispatch("InsuranceFee/getInsuranceTotal");
                this.$store.dispatch("RRPayoff/clearTransaction");
                this.pay.total_amount = this.driver.insurance_fee_total;
                this.$store.dispatch("InsuranceFee/getQuitData", this.driver.id).then(res => {
                    this.quit_list = res;
                })
            })
        },
        customLabelBank(option) {
            return `${option.account_number} - ${option.name}`
        },
        labelBranch(option) {
            return `${option.branch_code} - ${option.name}`
        },
        labelBank(option) {
            return `${option.text}`
        },
        showRemoveTransactionModal() {
            this.$refs.transaction.show();
        },
        hideRemoveTransactionModal() {
            this.$refs.transaction.hide();
        },
        showPayBackModal() {
            this.$refs.driver_pay.show();
        },
        hidePayBackModal() {
            this.$refs.driver_pay.hide();
        },
        saveEditData() {
            if (this.edit_data.income && this.edit_data.remove) {
                alert('กรุณาเลือกใส่จำนวนเงินอย่างใดอย่างหนึ่ง')
            } else if (!this.edit_data.income && !this.edit_data.remove) {
                alert('กรุณาเลือกใส่จำนวนเงินอย่างใดอย่างหนึ่ง')
            } else if (!this.edit_data.reason) {
                alert("กรุณาใส่เหตุผลในการแก้ไขจำนวนเงิน")
            } else {
                let remove_insurance = 0;
                if (this.edit_data.remove) {
                    remove_insurance = parseFloat(this.edit_data.remove);
                }
                let data = {
                    driver_id: this.driver.id,
                    amount: this.edit_data.income ? this.edit_data.income : remove_insurance ? remove_insurance : 0,
                    date: moment().format("YYYY-MM-DD"),
                    status_id: 2,
                    recipient: this.user.name,
                    reason: this.edit_data.reason
                };
                this.$store.dispatch("InsuranceFee/save", data).then(res => {
                    if (res) {
                        this.hideRemoveTransactionModal();
                        alert("บันทึกสำเร็จ");
                        this.edit_data = {
                            income: '',
                            remove: '',
                            reason: ''
                        };
                        this.$store.dispatch("InsuranceFee/showInsurance", {
                            driver_id: this.driver.id,
                            page: 1,
                        }).then(() => {
                            this.$store.dispatch('Driver/getDriverById', this.driver.id).then(() => {
                                this.pay.total_amount = this.driver.insurance_fee_total;
                            })
                        })
                    } else {
                        alert('ไม่สามารถบันทึกประกันได้ เนื่องจากมียอดประกันไม่ถูกต้อง');
                    }

                }).catch(err => {
                    alert("บันทึกไม่สำเร็จ");
                });
            }
        },
        getPage() {
            this.$store.dispatch("InsuranceFee/showInsurance", {
                driver_id: this.driver.id,
                page: this.dataPaginate.current_page,
            })
        },
        addCheque() {
            this.transaction.cheque = [
                ...this.transaction.cheque,
                {
                    transaction_type_id: 1,
                    ref_no: "",
                    date: "",
                    bank_name: "",
                    bank_branch: "",
                    amount: "",
                    description: "รายการจ่ายเงิน-จ่ายชำระหนี้",
                    bank_id: "",
                    bank: null,
                }
            ]
        },
        addTransfer() {
            this.transaction.transfer = [
                ...this.transaction.transfer,
                {
                    transaction_type_id: 2,
                    ref_no: "",
                    date: "",
                    bank_name: "",
                    bank_branch: "",
                    amount: "",
                    description: "รายการจ่ายเงิน-จ่ายชำระหนี้",
                    bank_id: "",
                    bank: null,
                }
            ]
        },
        removeCheque(index) {
            this.transaction.cheque = this.transaction.cheque.filter(
                (detail, itemIndex) => index !== itemIndex
            );
        },
        removeTransfer(index) {
            this.transaction.transfer = this.transaction.transfer.filter(
                (detail, itemIndex) => index !== itemIndex
            );
        }
    }
}
</script>

<style scoped>
thead {
    background-color: lightgray;
    color: black;
}

tbody {
    background-color: white;
    color: black;
}
</style>
